// Path: src/Screens/NotFound/PageNotFound.jsx
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../../assets/css/user/general/pagenotfound/PageNotFound.css';

// ── Bubbles data (random positions & sizes) ──
const BUBBLES = [
  { size: 18, left:  5, delay: 0,   dur: 8  },
  { size: 12, left: 10, delay: 1.5, dur: 10 },
  { size: 24, left: 18, delay: 0.5, dur: 7  },
  { size: 10, left: 25, delay: 3,   dur: 12 },
  { size: 20, left: 33, delay: 1,   dur: 9  },
  { size: 14, left: 40, delay: 2.5, dur: 11 },
  { size: 28, left: 48, delay: 0.8, dur: 8  },
  { size: 10, left: 55, delay: 4,   dur: 13 },
  { size: 16, left: 62, delay: 1.2, dur: 7  },
  { size: 22, left: 70, delay: 2,   dur: 10 },
  { size: 12, left: 77, delay: 3.5, dur: 9  },
  { size: 26, left: 84, delay: 0.3, dur: 11 },
  { size: 10, left: 90, delay: 2.8, dur: 8  },
  { size: 18, left: 96, delay: 1.8, dur: 12 },
  { size: 14, left: 14, delay: 4.5, dur: 10 },
  { size: 20, left: 58, delay: 5,   dur: 9  },
  { size: 10, left: 72, delay: 3.2, dur: 13 },
  { size: 16, left: 88, delay: 0.6, dur: 7  },
];

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="nf-page">

      {/* ── Floating decorative blobs ── */}
      <div className="nf-blob nf-blob-1" />
      <div className="nf-blob nf-blob-2" />
      <div className="nf-blob nf-blob-3" />

      {/* ── Bubbles ── */}
      <div className="nf-bubbles-container">
        {BUBBLES.map((b, i) => (
          <span
            key={i}
            className="nf-bubble"
            style={{
              width:           b.size,
              height:          b.size,
              left:            `${b.left}%`,
              animationDelay:  `${b.delay}s`,
              animationDuration:`${b.dur}s`,
            }}
          />
        ))}
      </div>

      <Container className="nf-container">
        <Row className="align-items-center justify-content-center min-vh-100">

          {/* ── Left: Illustration side ── */}
          <Col lg={5} md={6} className="nf-illustration-col">
            <div className="nf-illustration-wrapper">

              {/* Giant 404 behind illustration — dark orange */}
              <div className="nf-bg-text">404</div>

              {/* Tractor SVG illustration */}
              <div className="nf-tractor-wrap">
                <svg viewBox="0 0 260 200" xmlns="http://www.w3.org/2000/svg" className="nf-tractor-svg">
                  {/* Ground */}
                  <ellipse cx="130" cy="185" rx="110" ry="8" fill="#f0f0f0"/>

                  {/* Body */}
                  <rect x="60" y="90" width="110" height="65" rx="10" fill="#FDB714"/>
                  <rect x="70" y="75" width="60" height="40" rx="8" fill="#FDB714"/>

                  {/* Cabin glass */}
                  <rect x="75" y="80" width="50" height="28" rx="5" fill="#fff" opacity="0.6"/>

                  {/* Hood */}
                  <rect x="155" y="105" width="40" height="30" rx="6" fill="#e6a800"/>
                  <rect x="185" y="110" width="15" height="6" rx="3" fill="#c8920a"/>

                  {/* Exhaust pipe */}
                  <rect x="188" y="88" width="7" height="22" rx="3" fill="#333"/>
                  <ellipse cx="191" cy="87" rx="5" ry="3" fill="#555"/>

                  {/* Smoke puffs */}
                  <circle cx="191" cy="76" r="6" fill="#ddd" opacity="0.7" className="nf-smoke nf-smoke-1"/>
                  <circle cx="196" cy="65" r="4" fill="#ddd" opacity="0.5" className="nf-smoke nf-smoke-2"/>
                  <circle cx="188" cy="57" r="3" fill="#ddd" opacity="0.3" className="nf-smoke nf-smoke-3"/>

                  {/* Big rear wheel */}
                  <circle cx="95" cy="158" r="32" fill="#222"/>
                  <circle cx="95" cy="158" r="24" fill="#333"/>
                  <circle cx="95" cy="158" r="10" fill="#FDB714"/>
                  {[0,45,90,135,180,225,270,315].map((deg, i) => (
                    <line key={i}
                      x1="95" y1="158"
                      x2={95 + 20 * Math.cos(deg * Math.PI / 180)}
                      y2={158 + 20 * Math.sin(deg * Math.PI / 180)}
                      stroke="#FDB714" strokeWidth="2.5"/>
                  ))}

                  {/* Small front wheel */}
                  <circle cx="175" cy="163" r="18" fill="#222"/>
                  <circle cx="175" cy="163" r="12" fill="#333"/>
                  <circle cx="175" cy="163" r="5" fill="#FDB714"/>
                  {[0,60,120,180,240,300].map((deg, i) => (
                    <line key={i}
                      x1="175" y1="163"
                      x2={175 + 10 * Math.cos(deg * Math.PI / 180)}
                      y2={163 + 10 * Math.sin(deg * Math.PI / 180)}
                      stroke="#FDB714" strokeWidth="2"/>
                  ))}

                  {/* Farmer character */}
                  <rect x="100" y="95" width="22" height="26" rx="4" fill="#4a90d9"/>
                  <circle cx="111" cy="88" r="10" fill="#f5c5a3"/>
                  <ellipse cx="111" cy="80" rx="13" ry="3" fill="#8B4513"/>
                  <rect x="106" y="72" width="10" height="9" rx="2" fill="#8B4513"/>
                  <circle cx="108" cy="87" r="1.5" fill="#333"/>
                  <circle cx="114" cy="87" r="1.5" fill="#333"/>
                  <ellipse cx="111" cy="92" rx="2.5" ry="2" fill="#c0392b"/>

                  {/* Floating ? and ! */}
                  <text x="130" y="60" fontSize="22" fontWeight="900" fill="#FDB714" opacity="0.9"
                    fontFamily="Arial" className="nf-float">?</text>
                  <text x="48" y="72" fontSize="16" fontWeight="700" fill="#FDB714" opacity="0.6"
                    fontFamily="Arial" className="nf-float-slow">!</text>
                </svg>
              </div>
            </div>
          </Col>

          {/* ── Right: Content side ── */}
          <Col lg={5} md={6} className="nf-content-col">

            {/* Error code badge */}
            <div className="nf-badge">
              <span className="nf-badge-dot" />
              Error 404
            </div>

            {/* Heading */}
            <h1 className="nf-heading">
              Oops! You've<br />
              <span className="nf-heading-accent">Lost Your Way</span>
            </h1>

            {/* Subtext */}
            <p className="nf-subtext">
              Looks like this field hasn't been plowed yet.
              The page you're looking for doesn't exist or has been moved.
            </p>

            {/* Divider line */}
            <div className="nf-divider" />

            {/* Quick links */}
            {/* <div className="nf-quick-links">
              <span className="nf-quick-label">Quick Links:</span>
              {['Dashboard', 'Categories', 'Blogs'].map(link => (
                <button
                  key={link}
                  className="nf-quick-btn"
                  onClick={() => navigate('/')}
                >
                  {link}
                </button>
              ))}
            </div> */}

            {/* CTA Button — manual only, no auto redirect */}
            <Button
              className="nf-home-btn"
              onClick={() => navigate('/')}
            >
              ← Back to Home
            </Button>

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PageNotFound;